(function (factory) {
	if (typeof module !== "undefined" && module.exports) {
		module.exports = factory;
	} else {
		factory(jQuery, window, document);
	}
}(function ($) {
	$.id_placeholder = function (el, options) {
		const _this = this,
			$element = $(el);
		this.$label = null;
		this.init = function () {
			this.options = $.extend({}, $.id_placeholder.defaultOptions, options);
			const type = $(el).attr('type');
			// execute only on textareas and not forbidden input types
			// also check that element is not select2 injected <input> by checking if parent contains a select...
			// select2 type (search) is not known yet and classes are not accessible
			if ($element.prop('tagName') === 'TEXTAREA' || ($.inArray( type, this.options.forbiddenTypes ) === -1 )) {
				$element.attr('placeholder', '');

				// find item label
				// up to 1 more level if textarea
				if ($element.prop('tagName') === 'TEXTAREA') {
          this.$label = $element.parent().parent().addClass('rel').find('label');
        } else {
          this.$label = $element.parent().addClass('rel').find('label');
        }


				this.$label.addClass('inputplaceholder');
				this.$label.off('click').on('click', function (e) {
					e.preventDefault();
					$(this).addClass('focused');
					$element.focus();
				});
				$element.off('focus').on('focus', function (e) {
					e.preventDefault();
					_this.$label.addClass('focused');
				});

				$element.off('blur').on('blur', function (e) {
					e.preventDefault();
					if ($(this).val() === '') {
						_this.$label.removeClass('focused');
					}
				});
			}
		};
		this.init();
	};

	$.id_placeholder.defaultOptions = {
		'forbiddenTypes': ['radio', 'checkbox', 'submit', 'hidden', 'undefined'],
	};

	$.fn.id_placeholder = function (options) {
		return this.each(function () {
			(new $.id_placeholder(this, options));
		});
	};
}));
